const enum DeviceCategory {
  CorrosionErosionMonitoring = 1,
  Discrete = 2,
  FlameGasDetection = 3,
  FlowMeasurement = 4,
  Gateway = 5,
  LevelMeasurement = 6,
  PressureMeasurement = 7,
  TemperatureMeasurement = 8,
  VibrationMonitoring = 9,
  WirelessAccessories = 10,
  Antenna = 11,
  Other = 100,
}

export default DeviceCategory;
